import { Component, input, output } from '@angular/core';
import { IconComponent } from '../../../../../../../components/pay-icon/icon.component';
import { IconNames } from '../../../../../../../components/pay-icon/IconNames';
import { DateAgoPipe } from '../../../../utils/date-ago/date-ago.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'pay-login-last-used-emails',
  imports: [DateAgoPipe, IconComponent, TranslatePipe],
  templateUrl: './last-used-emails.html',
})
export class LastUsedEmails {
  protected readonly IconNames = IconNames;

  readonly emailClicked = output<{ uuid: string; email: string; lastUsedAt: Date }>();
  readonly emailDeleteClicked = output<string>();
  readonly emails = input.required<
    {
      uuid: string;
      email: string;
      lastUsedAt: Date;
    }[]
  >();

  protected emailClickedHandler(email: { uuid: string; email: string; lastUsedAt: Date }) {
    this.emailClicked.emit(email);
  }

  protected emailDeleteClickHandler(e: MouseEvent, email: string) {
    e.preventDefault();
    this.emailDeleteClicked.emit(email);
  }
}
